module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list reserved-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("储备老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "老师ID / 姓名 / 邮箱"
    },
    model: {
      value: (_vm.queryParam.keyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "keyword", $$v)
      },
      expression: "queryParam.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国籍"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "国籍"
    },
    model: {
      value: (_vm.queryParam.nationality),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nationality", $$v)
      },
      expression: "queryParam.nationality"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 20
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "stripe": "",
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": "",
      "show-elevator": "",
      "page-size-opts": [10, 20, 50, 100],
      "placement": "top"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.loadList,
      "recruit-flow-entry": "储备老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f05412a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/TchReservedList.vue
// module id = 1984
// module chunks = 8